import { render, staticRenderFns } from "./ForumRightSidebar.vue?vue&type=template&id=2174d548&scoped=true&"
import script from "./ForumRightSidebar.vue?vue&type=script&lang=js&"
export * from "./ForumRightSidebar.vue?vue&type=script&lang=js&"
import style0 from "./ForumRightSidebar.vue?vue&type=style&index=0&id=2174d548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2174d548",
  null
  
)

export default component.exports